import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "none",
      d: "M0 0h24v24H0z"
    }, null, -1),
    _createElementVNode("path", { d: "M19 4v16H7a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" }, null, -1),
    _createElementVNode("path", { d: "M19 16H7a2 2 0 0 0-2 2M9 8h6" }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })